<template>
    <div class="page">
      <el-pagination background
        @current-change="handleSizeChange"
        :current-page.sync="pagination.page"
        :page-size="pagination.pagesize"
        :pager-count="11"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
</template>
<!--layout="total, prev, pager, next, jumper"-->

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'page',
    props: ['total'],
    data() {
        return {
            pagination: {
                page: 1,
                pagesize: 10
            }
        }
    },
    created() {
        this.pagination = this.page
    },
    methods: {
        handleSizeChange(val) {
            this.pagination.page = val
            let page = {page: val, pagesize: 10}
            this.$store.commit('SET_PAGE', page)
            this.$emit('getList', page)
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .page {
      margin-top: 20px;
        @include flexBox(center)
    }
</style>
